import React, { useState, useEffect } from 'react'
import Axios from 'axios'
import { getUser } from '../../actions/session'
import { MONETARY_STATS_GRAPH } from '../../config/rest_endpoints'
import LineGraph from '../common/graphs/lineGraph'
import VerticalBarGraph from '../common/graphs/verticalBar'
import DatePicker from "react-datepicker";
import { Notifications } from '../common/notification'
import Select from 'react-select';


const MultiGraph = () => {
  const [stats, setStat] = useState({
    dates: [],
    cost: [],
    profit: [],
    revenue: []
  })
  const [statsSums, setStatSums] = useState({
    cost: [],
    profit: [],
    revenue: []
  })
  const [selectInterval, setSelectInterval] = useState({ value: 'week', label: 'week' })
  const [intervalOptions] = useState([
      { value: 'week', label: 'week' },
      { value: 'fortnight', label: 'fortnight' },
       { value: 'month', label: 'month' },
      { value: 'half-year', label: 'half-year' },
      { value: 'year', label: 'year' }
    ])
    const [User] = useState(getUser())

  useEffect(() => {
    getStats()
  }, [selectInterval])

  const handleSelectInterval = (selectInterval) => {
    setSelectInterval(selectInterval)
  }

  const getStats = () => {
    var payload = {
      "statsDur": selectInterval.value
    }
    var headers = { 'Authorization': "Bearer " + User.token }
    Axios.post(MONETARY_STATS_GRAPH, payload, { headers }).then(res => {
      if (res) {
        let data = res.data.data
        let setDate = data.date.map(da => da.split('T')[0])
        const costSum = data.cost.reduce((a, b) => a + b, 0)
        const profitSum = data.profit.reduce((a, b) => a + b, 0)
        const revenueSum = data.revenue.reduce((a, b) => a + b, 0)
        setStatSums({
          cost: costSum.toFixed(3),
          profit: profitSum.toFixed(3),
          revenue: revenueSum.toFixed(3)
        })
        setStat({
          dates: setDate,
          cost: data.cost,
          profit: data.profit,
          revenue: data.revenue
        })
      }
    }).catch(err => {
      const alert = err.response && err.response.data
      Notifications.notify(alert.message, "Failed", "error")

    })
  }

  const summaryItems = [
    { label: 'Sum of Cost', value: statsSums.cost, color: '#EF4444' },
    { label: 'Sum of Profit', value: statsSums.profit, color: '#10B981' },
    { label: 'Sum of Revenue', value: statsSums.revenue, color: '#8B5CF6' }
  ];


  return (
    <div className="row" style={{marginBottom: '20px'}}>
      <div className="col-md-12">
        <div style={{
          background: '#fff',
          borderRadius: '12px',
          border: '1px solid #E2E8F0',
          boxShadow: '0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.06)',
          overflow: 'hidden',
          animation: 'fadeInUp 0.5s ease forwards',
          animationDelay: '0.2s',
          opacity: 0
        }}>
          {/* Header */}
          <div style={{
            padding: '20px 24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '1px solid #F1F5F9'
          }}>
            <div>
              <h4 style={{
                fontSize: '16px',
                fontWeight: '600',
                color: '#0F172A',
                margin: 0,
                letterSpacing: '-0.01em'
              }}>System Monetary Stats</h4>
              <p style={{
                fontSize: '12px',
                color: '#94A3B8',
                margin: '2px 0 0'
              }}>Revenue, cost and profit overview</p>
            </div>
            <div style={{minWidth: '160px'}}>
              <Select
                value={selectInterval}
                onChange={handleSelectInterval}
                options={intervalOptions}
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: '#E2E8F0',
                    borderRadius: '8px',
                    minHeight: '36px',
                    fontSize: '13px',
                    boxShadow: 'none',
                    '&:hover': { borderColor: '#CBD5E1' }
                  }),
                  option: (base, state) => ({
                    ...base,
                    fontSize: '13px',
                    padding: '8px 12px',
                    backgroundColor: state.isSelected ? '#ECFDF5' : state.isFocused ? '#F8FAFC' : '#fff',
                    color: state.isSelected ? '#047857' : '#475569',
                    borderRadius: '6px'
                  }),
                  menu: (base) => ({
                    ...base,
                    borderRadius: '12px',
                    border: '1px solid #E2E8F0',
                    boxShadow: '0 10px 25px rgba(0,0,0,0.08)',
                    padding: '4px',
                    overflow: 'hidden'
                  }),
                  menuList: (base) => ({
                    ...base,
                    padding: 0
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: '#0F172A',
                    fontWeight: '500',
                    textTransform: 'capitalize'
                  })
                }}
              />
            </div>
          </div>

          {/* Summary stats row */}
          <div style={{
            display: 'flex',
            borderBottom: '1px solid #F1F5F9'
          }}>
            {summaryItems.map((item, idx) => (
              <div key={idx} style={{
                flex: 1,
                padding: '16px 24px',
                textAlign: 'center',
                borderRight: idx < summaryItems.length - 1 ? '1px solid #F1F5F9' : 'none'
              }}>
                <p style={{
                  fontSize: '12px',
                  fontWeight: '500',
                  color: '#94A3B8',
                  margin: '0 0 4px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.03em'
                }}>{item.label}</p>
                <h5 style={{
                  fontSize: '18px',
                  fontWeight: '700',
                  color: '#0F172A',
                  margin: 0,
                  letterSpacing: '-0.02em'
                }}>
                  <span style={{
                    display: 'inline-block',
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    background: item.color,
                    marginRight: '8px'
                  }}></span>
                  ${item.value}
                </h5>
              </div>
            ))}
          </div>

          {/* Chart area */}
          <div style={{padding: '16px 20px 20px'}}>
            <LineGraph
              title="Cost"
              title1="Profit"
              title2="Revenue"
              x={stats.dates}
              y={stats.cost}
              y1={stats.profit}
              y2={stats.revenue}
              width={700}
              height={300}
              lineColor="#EF4444"
              lineColor1="#10B981"
              lineColor2="#8B5CF6"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default MultiGraph
